import { formatReleaseDate, isPreorderActive } from '../../utils/preorder';

const PreorderBadge = ({ book, compact = false }) => {
  if (!isPreorderActive(book)) return null;
  return (
    <span className={`inline-flex items-center rounded-full bg-violet-100 font-semibold text-violet-800 ${compact ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'}`}>
      Pre-order{!compact && <><span className="mx-1">· Releases</span><span className="font-bold text-orange-600">{formatReleaseDate(book.preorderReleaseDate)}</span></>}
    </span>
  );
};

export default PreorderBadge;
